﻿// See also BannedEmailDomain.cs
export const illegalDomains = [
    "mailinator.com",
    "dayrep.com",
    "teleworm.us",
    "test.com",
    "no.com",
    "hushmail.com"
];